import React from 'react'
import { styles } from './index.sass'
import { ContentGenerator } from '../../components/contentGenerator/ContentGenerator'
import { sendEmail, sendTestEmail } from '../../api/mailchimp'
import { refinePowerList } from '../../api/contentGeneration'

export const PowerList = () => {
  const handleGenerate = async (topic, regenerate, onStepUpdate) => {
    return new Promise((resolve, reject) => {
      const params = new URLSearchParams({
        regenerate: true,
        topic: topic
      })
      const url = `${process.env.REACT_APP_ML_API_ENDPOINT}/api/ml/generate-powerlist-stream?${params.toString()}`
      const eventSource = new EventSource(url)

      eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data)
        
        if (data.step !== undefined && onStepUpdate) {
          onStepUpdate(data)
        } else if (data.status === 'success') {
          eventSource.close()
          resolve({
            success: true,
            content_html: data.content_html,
            message: 'Power List generated successfully!'
          })
        } else if (data.status === 'error') {
          eventSource.close()
          reject(new Error(data.message || 'Failed to generate Power List'))
        }
      }

      eventSource.onerror = () => {
        eventSource.close()
        reject(new Error('Stream connection error'))
      }
    })
  }

  const handleLoadTestData = (setContentHtml) => {
    const testContent = `
      <h1>Power List for Weight Loss</h1>
      <p>Here's a curated list of resources to help you achieve your weight loss goals:</p>
      
      <h2>1. Diet and Nutrition</h2>
      <ul>
        <li>Importance of balanced macronutrients</li>
        <li>Calorie deficit principles</li>
        <li>Meal prep tips for success</li>
      </ul>
      
      <h2>2. Exercise Routines</h2>
      <ul>
        <li>Cardiovascular exercises</li>
        <li>Strength training basics</li>
        <li>HIIT workout examples</li>
      </ul>
      
      <h2>3. Lifestyle Changes</h2>
      <ul>
        <li>Importance of sleep</li>
        <li>Stress management techniques</li>
        <li>Hydration guidelines</li>
      </ul>
      
      <p>Remember, consistency is key! Consult with a healthcare professional before starting any new diet or exercise program.</p>
    `
    setContentHtml(testContent)
  }

  return (
    <div className={styles}>
      <ContentGenerator
        title="Power List Content Generator"
        inputPlaceholder="Enter the topic or theme for the Power List (e.g., 'Power List for Weight Loss')"
        generateButtonText="Generate Power List"
        regenerateButtonText="Regenerate"
        editButtonText="Refine with AI"
        sendEmailButtonText="Send Email"
        sendTestEmailButtonText="Send Test Email"
        loadTestDataButtonText="Load Test Data"
        onGenerate={handleGenerate}
        onRefine={refinePowerList}
        onSendEmail={sendEmail}
        onSendTestEmail={sendTestEmail}
        onLoadTestData={handleLoadTestData}
      />
    </div>
  )
}
